module.exports = __webpack_public_path__ + "img/back_21.86edba0f.svg";